import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "accordion-header" }
const _hoisted_2 = ["data-bs-target", "aria-controls"]
const _hoisted_3 = { class: "container-fluid p-0" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"green"}
}
const _hoisted_9 = {
  key: 1,
  style: {"color":"orange"}
}
const _hoisted_10 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "accordion-body" }
const _hoisted_14 = { class: "container-fluid p-0" }
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col envio-detalles" }
const _hoisted_17 = { class: "list-group list-group-flush" }
const _hoisted_18 = { class: "badge bg-primary rounded-pill" }
const _hoisted_19 = {
  key: 0,
  class: "col envio-detalles"
}
const _hoisted_20 = { class: "list-group list-group-flush" }
const _hoisted_21 = { class: "badge bg-primary rounded-pill" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "envio-details mx-2 mt-3" }
const _hoisted_24 = { class: "description-text" }
const _hoisted_25 = { class: "row mt-3" }
const _hoisted_26 = { class: "col text-end" }

import { ref } from 'vue';
import type { Envio } from '@/types/envioTypes';

import { useEnviosStore } from '@/stores/useEnvioStore';
import { Pencil, Square, SquareX } from 'lucide-vue-next';

import { Wrench, UserRound, Phone, CalendarClock } from 'lucide-vue-next';
import { Calculator, Store, SquareCheck, KeyRound } from 'lucide-vue-next';

import EnvioFormComponent from './EnvioFormComponent.vue';
import IncidentItemComponent from '../incidents/IncidentItemComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvioItemComponent',
  props: {
    envio: {}
  },
  setup(__props: any) {

const props = __props;
const envioStore = useEnviosStore();

const isEditFormModalOpen = ref(false);
const editingEnvio = ref<Envio | null>(null);

console.log("ENVIO:")
console.log(props)

// Función para formatear la fecha y la hora
const formatDateTime = (date: string | null | undefined, time: string | null | undefined): string => {
  if (!date) return "N/A";

  let formattedDate = new Date(date).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  let formattedTime = time ? time.slice(0, 5) : "";

  return time ? `${formattedDate} ${formattedTime}` : formattedDate;
};

const openEditFormModal = (envio: Envio) => {
  /* console.log("Operator Name: " + envio.operator_name) */
  editingEnvio.value = envio;
  isEditFormModalOpen.value = true;
};

const handleCloseEditFormModal = () => {
  editingEnvio.value = null;
  isEditFormModalOpen.value = false;
};

const handleSubmitEditFormModal = async () => {
  await envioStore.fetchEnvios();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, [
      _createElementVNode("button", {
        class: "accordion-button collapsed w-100 border-top border-primary",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": `#collapse${_ctx.envio.id}`,
        "aria-expanded": "false",
        "aria-controls": `collapse${_ctx.envio.id}`
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.envio.id), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.envio.expendeduria_nombre), 1),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.envio.status==='enviado')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(SquareCheck)),
                    _cache[1] || (_cache[1] = _createTextVNode(" Enviado"))
                  ]))
                : (_ctx.envio.status==='pendiente')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_unref(Square)),
                      _cache[2] || (_cache[2] = _createTextVNode(" Pendiente"))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_unref(SquareX)),
                      _cache[3] || (_cache[3] = _createTextVNode("Cancelado"))
                    ]))
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.envio.date), 1)
          ])
        ])
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      id: `collapse${_ctx.envio.id}`,
      class: "accordion-collapse collapse text-start"
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[4] || (_cache[4] = _createElementVNode("h5", null, "Detalles del envio ", -1)),
              _createElementVNode("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.envio.detalles.filter(d => d.tipo === 'envio'), (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.id,
                    class: "list-group-item d-flex justify-content-between align-items-center"
                  }, [
                    _createTextVNode(_toDisplayString(item.producto_nombre) + " ", 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.cantidad), 1)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.envio.with_return)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Detalles del retorno ", -1)),
                  _createElementVNode("ul", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.envio.detalles.filter(d => d.tipo === 'retorno'), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "list-group-item d-flex justify-content-between align-items-center"
                      }, [
                        _createTextVNode(_toDisplayString(item.producto_nombre) + " ", 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.cantidad), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[6] || (_cache[6] = _createElementVNode("h5", null, "Descripción:", -1)),
              _createElementVNode("pre", _hoisted_24, _toDisplayString(_ctx.envio.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openEditFormModal(_ctx.envio))),
                disabled: true
              }, [
                _createVNode(_unref(Pencil)),
                _cache[7] || (_cache[7] = _createTextVNode(" Editar "))
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_12),
    _createVNode(EnvioFormComponent, {
      show: isEditFormModalOpen.value,
      envio: editingEnvio.value,
      onClose: handleCloseEditFormModal,
      onSubmit: handleSubmitEditFormModal
    }, null, 8, ["show", "envio"])
  ], 64))
}
}

})